import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import isEqual from 'lodash-es/isEqual'
import pick from 'lodash-es/pick'
import omitBy from 'lodash-es/omitBy'
import querystring from 'query-string'

import {
  searchApiParams,
  searchApiFilterParams
} from '../constants/searchQueryWhitelist'
import filterParamsConfig from '../constants/filterParamsConfig'
import { getConfigBySite } from '../../config/sites'
import { sanitizeSearchTerm } from './sanitize'
import getDefaultSortParam from './location/getDefaultSortParam'
import { getMillisecondsForLastHour } from './time'

export const isCategoryOnlySearch = query => {
  return includesExactlyTheseFacetingParams(query, ['category'])
}

export const isFirstPage = query => {
  return isEmpty(query.page) || [0, 1].includes(parseInt(query.page))
}

export const includesExactlyTheseFacetingParams = (
  query,
  expectedParamKeys
) => {
  const queryFacetingParams = pick(query, searchApiFilterParams)
  const queryFacetingParamsWithValues = omitBy(queryFacetingParams, isEmpty)
  const facetingParamKeys = Object.keys(queryFacetingParamsWithValues)

  return isEqual(facetingParamKeys.sort(), expectedParamKeys.sort())
}

// Determines sort method in order of priority:
// if there's a `sort_by` filter provided then use it
// otherwise check whether query has a search term, if yes use `relevance`
// otherwise use the default sort param for the site
export const determineSortMethod = (filteredQueryObject, currentSite) => {
  const sortByRelevanceIfTermPresent = filteredQueryObject.term && 'relevance'
  return (
    filteredQueryObject.sort_by ||
    sortByRelevanceIfTermPresent ||
    getDefaultSortParam(filteredQueryObject, currentSite)
  )
}

/**
 * Build the search query string
 * @param  {Object} query
 * @return {String} the search query string pass to market-search
 */

export const buildSearchQueryString = (parsedLocation, currentSite) => {
  const filteredQueryObject = Object.keys(parsedLocation)
    .filter(param => {
      // only keep the queries in the market-search query whitelist
      return searchApiParams.indexOf(param) >= 0
    })
    .filter(param => {
      // filter empty params
      return !!parsedLocation[param]
    })
    .reduce((prev, curr) => {
      if (Array.isArray(parsedLocation[curr])) {
        const arrayLength = parsedLocation[curr].length
        prev[curr] = parsedLocation[curr][arrayLength - 1]
      } else if (get(filterParamsConfig, `${curr}.isArrayFormat`)) {
        prev[curr] = parsedLocation[curr].split(',')
      } else {
        prev[curr] = parsedLocation[curr]
      }
      return prev
    }, {})

  // format search term sent to server
  if (filteredQueryObject.term) {
    filteredQueryObject.term = sanitizeSearchTerm(filteredQueryObject.term)
  }

  const pageSize = getConfigBySite(currentSite, 'common.search_page_size')
  const site = `${currentSite}.net`

  // we have a few default value here
  const newQueryObject = Object.assign({}, filteredQueryObject, {
    site,
    page: filteredQueryObject.page || 1,
    page_size: filteredQueryObject.page_size || pageSize,
    sort_by: determineSortMethod(filteredQueryObject, currentSite)
  })

  if (newQueryObject.sort_by === 'random') {
    newQueryObject.salt = getMillisecondsForLastHour()
  }

  return querystring.stringify(newQueryObject, { arrayFormat: 'bracket' })
}
